import React, { useState } from "react";
import { FcBusinessman, FcLeft, FcPrevious } from "react-icons/fc";
import { useNavigate } from "react-router";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import { useSelector } from "react-redux";
import { Field, Form, Formik } from "formik";
import { farmerPartnerSchema } from "../../../Schemas/Epg Farmer/farmer_partner_schema";
import { farmerPartnerInfo } from "../../../SchemaInfo/Epg Info/farmer_partner";
import SimpleButton from "../../../Components/layouts/simple_button";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import CustomInput from "../../../CustomComponent/custom_input";
import { IoIosArrowBack } from "react-icons/io";

const OnboardFarmerPartner = () => {
  const navigate = useNavigate();
  const store = useSelector((store) => store?.login?.user);

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    console.log("reached here", values);

    try {
      setLoading(true);

      let formData = new FormData();
      for (let key in values) {
        formData.append(key, values[key]);
      }
      const headers = { "Content-Type": "multipart/form-data" };
      const res = await performRequest(
        "POST",
        "/pmg/farmer-partner/create-farmer-partner",
        formData,
        headers
      );

      if (res?.status === 200 || res?.status === 201) {
        Toast("success", "Farmer Partner onboarded successfully!");
        navigate("/farmer-partners");
      } else {
        Toast("error", "Unable to onboard farmer partner");
      }
    } catch (err) {
      if (err.response?.data?.message) {
        Toast("error", err.response?.data?.message);
      } else {
        CustomErrorResponse(err);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none m-0">
            <div className="col d-flex justify-content-between">
              <div>
                <h2 className="page-title mb-1 mt-4">
                  <FcBusinessman className="fs-2 me-1" /> Onboard Farmer Partner
                </h2>
                <h4 className="text-muted m-0 p-0">
                  Create and register a new farmer partner.
                </h4>
              </div>
              <div className="mt-4">
                <button
                  className="btn btn-secondary"
                  onClick={() => navigate("/farmer-partners")}
                >
                  <IoIosArrowBack /> Back
                </button>
              </div>
            </div>
          </div>

          <div className="row py-3">
            <div className="col-md-3 col-sm-12 mb-3 py-2">
              <div className="card p-3">
                <h4 className="mb-3">Quick Notes</h4>
                <ul className="mb-0 ps-3">
                  <li>Client Id is mandatory</li>
                  <li>Email and contact number should be unique</li>
                  <li>Use service radius for nearby order assignment</li>
                  <li>Latitude and longitude can be added now or later</li>
                  <li>Opening and closing time helps availability tracking</li>
                </ul>
              </div>
            </div>

            <div className="col-md-9 col-sm-12 py-2">
              <div className="card p-4">
                <Formik
                  initialValues={farmerPartnerInfo}
                  validationSchema={farmerPartnerSchema}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {(props) => (
                    <Form>
                      <div className="card-body">
                        <div className="row g-3">
                          {/* Client Id */}
                          <div className="col-md-4">
                            <label className="form-label required">
                              Client Id
                            </label>
                            <CustomInput name="clientId" type="text" />
                            {props.touched.clientId &&
                              props.errors.clientId && (
                                <p className="text-danger">
                                  {props.errors.clientId}
                                </p>
                              )}
                          </div>

                          {/* Farmer Name */}
                          <div className="col-md-4">
                            <label className="form-label required">
                              Farmer Partner Name
                            </label>
                            <CustomInput name="farmPartnerName" type="text" />
                            {props.touched.farmPartnerName &&
                              props.errors.farmPartnerName && (
                                <p className="text-danger">
                                  {props.errors.farmPartnerName}
                                </p>
                              )}
                          </div>

                          {/* Store Name */}
                          <div className="col-md-4">
                            <label className="form-label">Store Name</label>
                            <CustomInput name="storeName" type="text" />
                          </div>

                          {/* Email */}
                          <div className="col-md-4">
                            <label className="form-label required">Email</label>
                            <CustomInput name="email" type="email" />
                            {props.touched.email && props.errors.email && (
                              <p className="text-danger">
                                {props.errors.email}
                              </p>
                            )}
                          </div>

                          {/* Contact */}
                          <div className="col-md-4">
                            <label className="form-label required">
                              Contact Number
                            </label>
                            <CustomInput
                              name="contactNumber"
                              type="text"
                              maxLength={10}
                            />
                            {props.touched.contactNumber &&
                              props.errors.contactNumber && (
                                <p className="text-danger">
                                  {props.errors.contactNumber}
                                </p>
                              )}
                          </div>

                          {/* Alternate Contact */}
                          <div className="col-md-4">
                            <label className="form-label">
                              Alternate Contact
                            </label>
                            <CustomInput
                              name="alternateContactNumber"
                              type="text"
                              maxLength={10}
                            />
                          </div>

                          {/* Address */}
                          <div className="col-md-6">
                            <label className="form-label">Address Line 1</label>
                            <CustomInput name="addressLine1" type="text" />
                          </div>

                          <div className="col-md-6">
                            <label className="form-label">Address Line 2</label>
                            <CustomInput name="addressLine2" type="text" />
                          </div>

                          {/* Location */}
                          <div className="col-md-4">
                            <label className="form-label">Village</label>
                            <CustomInput name="village" type="text" />
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">City</label>
                            <CustomInput name="city" type="text" />
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">State</label>
                            <CustomInput name="state" type="text" />
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">Pincode</label>
                            <CustomInput name="pincode" type="text" />
                            {props.touched.pincode && props.errors.pincode && (
                              <p className="text-danger">
                                {props.errors.pincode}
                              </p>
                            )}
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">Landmark</label>
                            <CustomInput name="landmark" type="text" />
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">Service Area</label>
                            <CustomInput name="serviceAreaName" type="text" />
                          </div>

                          {/* Geo */}
                          <div className="col-md-4">
                            <label className="form-label">Latitude</label>
                            <CustomInput name="latitude" type="number" />
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">Longitude</label>
                            <CustomInput name="longitude" type="number" />
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">
                              Service Radius (KM)
                            </label>
                            <CustomInput name="serviceRadiusKm" type="number" />
                          </div>

                          {/* Time */}
                          <div className="col-md-4">
                            <label className="form-label">Opening Time</label>
                            <CustomInput name="openingTime" type="time" />
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">Closing Time</label>
                            <CustomInput name="closingTime" type="time" />
                          </div>

                          {/* GST */}
                          <div className="col-md-4">
                            <label className="form-label">GST Number</label>
                            <CustomInput name="gstNumber" type="text" />
                          </div>

                          {/* Profile */}
                          {/* <div className="col-md-6">
                            <label className="form-label">
                              Profile Image URL
                            </label>
                            <CustomInput name="profileImage" type="text" />
                          </div> */}

                          <div className="col-md-6">
                            <label className="form-label">Profile Image</label>

                            <CustomInput
                              name="profileImage"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "profileImage",
                                  e.target.files[0]
                                )
                              }
                            />
                          </div>

                          <div className="col-md-6">
                            <label className="form-label">Notes</label>
                            <CustomInput name="notes" type="text" />
                          </div>

                          {/* Checkbox */}
                          <div className="col-md-3">
                            <div className="form-check mt-4">
                              <input
                                type="checkbox"
                                name="isActive"
                                checked={props.values.isActive}
                                onChange={props.handleChange}
                                className="form-check-input"
                              />
                              <label className="form-check-label">
                                Is Active
                              </label>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-check mt-4">
                              <input
                                type="checkbox"
                                name="isAvailable"
                                checked={props.values.isAvailable}
                                // onChange={props.handleChange}
                                className="form-check-input"
                              />
                              <label className="form-check-label">
                                Is Available
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Footer */}
                      <div className="card-footer">
                        <div className="d-flex gap-2 justify-content-end">
                          <FormSubmitButton
                            buttonText={
                              loading
                                ? "Submitting..."
                                : "Create Farmer Partner"
                            }
                          />
                          <SimpleButton
                            buttonText="Cancel"
                            type="secondary"
                            onClick={() => navigate("/farmer-partner")}
                          />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default OnboardFarmerPartner;

//   const handleSubmit = async (values) => {
//     try {
//       setLoading(true);

//       const payload = {
//         ...values,
//         latitude: values.latitude ? Number(values.latitude) : null,
//         longitude: values.longitude ? Number(values.longitude) : null,
//         serviceRadiusKm: values.serviceRadiusKm
//           ? Number(values.serviceRadiusKm)
//           : null,
//       };

//       const res = await performRequest(
//         "POST",
//         "/pmg/farmer-partner/create-farmer-partner",
//         payload
//       );

//       if (res?.status === 200 || res?.status === 201) {
//         Toast("success", "Farmer Partner onboarded successfully!");
//         navigate("/farmer-partner");
//       } else {
//         Toast("error", "Unable to onboard farmer partner");
//       }
//     } catch (err) {
//       CustomErrorResponse(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="page">
//       <div className="page-wrapper">
//         <div className="container-xxl">
//           <div className="page-header m-0">
//             <h2 className="page-title">
//               <FcBusinessman /> Onboard Farmer Partner
//             </h2>
//           </div>

//           <Formik
//             initialValues={farmerPartnerInfo}
//             validationSchema={farmerPartnerSchema}
//             onSubmit={handleSubmit}
//             enableReinitialize
//           >
//             {({ values, handleChange }) => (
//               <Form className="card p-4">
//                 <div className="row g-3">
//                   {/* Client Id */}
//                   <div className="col-md-4">
//                     <label>Client Id *</label>
//                     <Field
//                       name="clientId"
//                       type="number"
//                       className="form-control"
//                     />
//                     <ErrorMessage
//                       name="clientId"
//                       component="div"
//                       className="text-danger"
//                     />
//                   </div>

//                   {/* Name */}
//                   <div className="col-md-4">
//                     <label>Farmer Partner Name *</label>
//                     <Field name="farmPartnerName" className="form-control" />
//                     <ErrorMessage
//                       name="farmPartnerName"
//                       component="div"
//                       className="text-danger"
//                     />
//                   </div>

//                   {/* Email */}
//                   <div className="col-md-4">
//                     <label>Email *</label>
//                     <Field name="email" type="email" className="form-control" />
//                     <ErrorMessage
//                       name="email"
//                       component="div"
//                       className="text-danger"
//                     />
//                   </div>

//                   {/* Contact */}
//                   <div className="col-md-4">
//                     <label>Contact Number *</label>
//                     <Field name="contactNumber" className="form-control" />
//                     <ErrorMessage
//                       name="contactNumber"
//                       component="div"
//                       className="text-danger"
//                     />
//                   </div>

//                   {/* City */}
//                   <div className="col-md-4">
//                     <label>City</label>
//                     <Field name="city" className="form-control" />
//                   </div>

//                   {/* State */}
//                   <div className="col-md-4">
//                     <label>State</label>
//                     <Field name="state" className="form-control" />
//                   </div>

//                   {/* Latitude */}
//                   <div className="col-md-4">
//                     <label>Latitude</label>
//                     <Field
//                       name="latitude"
//                       type="number"
//                       className="form-control"
//                     />
//                   </div>

//                   {/* Longitude */}
//                   <div className="col-md-4">
//                     <label>Longitude</label>
//                     <Field
//                       name="longitude"
//                       type="number"
//                       className="form-control"
//                     />
//                   </div>

//                   {/* Checkbox */}
//                   <div className="col-md-3">
//                     <div className="form-check mt-4">
//                       <Field
//                         type="checkbox"
//                         name="isActive"
//                         className="form-check-input"
//                       />
//                       <label className="form-check-label">Is Active</label>
//                     </div>
//                   </div>

//                   {/* Submit */}
//                   <div className="col-12 mt-4">
//                     <button
//                       type="submit"
//                       className="btn btn-primary"
//                       disabled={loading}
//                     >
//                       {loading ? "Submitting..." : "Create Farmer Partner"}
//                     </button>
//                   </div>
//                 </div>
//               </Form>
//             )}
//           </Formik>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default OnboardFarmerPartner;
